import { JaneModalJaneDetailsQuery } from 'types/graphql';

export const canJaneHoldSkills = (
  jane: Pick<JaneModalJaneDetailsQuery['fetchJane'], 'agencyCommunity' | 'marketplaceJane'>,
  canManageSkills: boolean,
) => canManageSkills && !jane.agencyCommunity?.id && !jane.marketplaceJane;
